import { SpeakerWaveIcon } from '@heroicons/react/24/outline';
export const EarIcon = SpeakerWaveIcon;
